export const COLORS = {
  valhalla: {
    subtle: '#DCE4F7',
    light: '#B9C9EF',
    standard: '#4F77D8',
    hover: '#5B8AFF'
  },
  bethpage: {
    subtle: '#CFCFD1',
    light: '#86888B',
    standard: '#26292F',
    dark: '#0E1118'
  },
  whistling: {
    light: '#F7F8FA',
    standard: '#EFF1F5'
  },
  pebble: '#FAFAFC',
  ghost: '#FFFFFF',
  augusta: {
    subtle: '#E1EFE4',
    light: '#C3DEC9',
    standard: '#69AD78',
    dark: '#609D6E'
  },
  merion: {
    subtle: '#F7DDDD',
    light: '#F0BBBB',
    standard: '#D95656',
    dark: '#C44F50',
    hover: '#FB5B5B'
  },
  dune: {
    subtle: '#FDF1DF',
    light: '#F9DBAC',
    standard: '#F4BA61',
    dark: '#C08A00'
  },
  teal: {
    standard: '#3EA590',
    ten: '#ECF7F4',
    thirty: '#C5E4DD',
    sixty: '#8CCABD',
    hover: '#377E67'
  },
  coolGray: {
    ten: '#FAFAFB',
    thirty: '#EDEFF0',
    sixty: '#DCE0E3',
    standard: '#C5CCD0'
  },
  blue: {
    ten: '#EAEDF0',
    thirty: '#BDC6CF',
    sixty: '#7C8EA0',
    standard: '#244260'
  },
  mediumBlue: {
    ten: '#E6EEF2',
    thirty: '#B2C9D7',
    sixty: '#6695B0',
    standard: '#244260'
  },
  green: {
    standard: '#72C596',
    sixty: '#AADCC0',
    thirty: '#D4EDDF',
    ten: '#F1FAF5'
  },
  leadstarPurple: {
    standard: '#7F287F',
    sixty: '#B27EB2',
    thirty: '#D9BFD9',
    ten: '#F2E9F2',
    hover: '#AE37AE'
  },
  leadstarBlack: {
    standard: '#353535',
    sixty: '#868686',
    thirty: '#C2C2C2',
    ten: '#EBEBEB'
  }
} as const

export const SPACE = {
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '16px',
  l: '24px',
  xl: '32px',
  xxl: '64px',
  none: '0',
  auto: 'auto'
} as const

/*
 * We use 10px as a base font defined in the html
 * which makes it easy to use rem sizes
 */
export const FONT_SCALE = {
  body: {
    tiny: '1.1rem', // 11px
    small: '1.2rem', // 12px
    base: '1.4rem', // 14px
    big: '1.6rem', // 16px
    bigger: '1.8rem', // 18px
    huge: '2.4rem' //24px
  },

  headings: {
    hero: '4.2rem', // 42px
    jumbo: '3.2rem', // 32px
    h1: '2.4rem', // 24px
    h2: '2rem', // 20px
    h3: '1.8rem', // 18px
    h4: '1.6rem' // 16px
  }
} as const

export const BREAKPOINTS = {
  mobile: 720,
  tablet: 960,
  desktop: 1440
} as const
